module.exports = __webpack_public_path__ + "static/media/files__icon.4a2fcc4b.svg";